import { render, staticRenderFns } from "./SelectFile.vue?vue&type=template&id=60f4e247&scoped=true&"
import script from "./SelectFile.vue?vue&type=script&lang=js&"
export * from "./SelectFile.vue?vue&type=script&lang=js&"
import style0 from "./SelectFile.vue?vue&type=style&index=0&id=60f4e247&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f4e247",
  null
  
)

export default component.exports